/**
 * Sales-write identity helpers — Online Sales Server audit trail.
 *
 * docs/FRONTEND.md § Sales-write user field
 * Ticket #26328 / Sentry ONLINE-SALES-SERVER-API-1V + 1E
 * Rule: 2026-08-01 sales audit-trail integrity
 *
 * NEVER default to "System". Prefer Username (login id), never display Name.
 */
import * as Sentry from '@sentry/vue';
import { responses } from '@/utils/responses';

export const SALES_WRITE_SESSION_EXPIRED_MSG =
    'Your session has expired. Please sign in again before continuing.';

/**
 * @param {object|string|null|undefined} userOrString
 * @returns {string}
 */
export function resolveSalesWriteUsername(userOrString) {
    if (userOrString == null) return '';
    if (typeof userOrString === 'string') return userOrString.trim();
    const raw =
        userOrString.Username ??
        userOrString.username ??
        userOrString.user ??
        userOrString.User ??
        '';
    return typeof raw === 'string' ? raw.trim() : String(raw || '').trim();
}

/**
 * @param {object|string|null|undefined} userOrString
 * @param {string} contextLabel
 * @returns {string}
 */
export function requireSalesWriteUser(userOrString, contextLabel = 'unknown') {
    const username = resolveSalesWriteUsername(userOrString);
    if (!username) {
        try {
            Sentry.captureMessage(`sales-write missing user at ${contextLabel}`, {
                level: 'error',
                tags: { sales_write_user: 'missing', context: String(contextLabel) },
            });
        } catch (_) { /* optional */ }
        try {
            responses.throwErr(SALES_WRITE_SESSION_EXPIRED_MSG);
        } catch (_) { /* toast best-effort */ }
        const err = new Error(SALES_WRITE_SESSION_EXPIRED_MSG);
        err.code = 'SALES_WRITE_USER_REQUIRED';
        throw err;
    }
    return username;
}

export function assertSalesWriteUser(username, contextLabel = 'unknown') {
    return requireSalesWriteUser(username, contextLabel);
}
